import { render, staticRenderFns } from "./FoundKeywordNetworkCompliancePage.vue?vue&type=template&id=4bdaf72a&scoped=true&"
import script from "./FoundKeywordNetworkCompliancePage.vue?vue&type=script&lang=js&"
export * from "./FoundKeywordNetworkCompliancePage.vue?vue&type=script&lang=js&"
import style0 from "./FoundKeywordNetworkCompliancePage.vue?vue&type=style&index=0&id=4bdaf72a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdaf72a",
  null
  
)

export default component.exports